import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { AppMetaData } from '../../api/types'
import * as actions from '../../settings/actions'
import { Language } from '../../settings/types'
import { checkForUpdates } from '../actions'
import { getConfiguration } from '../../configuration'
import { fetchManifest } from '../../api/actions'
import { Manifest } from 'mytours-read-api-typescript'
import { loadForm } from '../../forms/actions'
import { FormStoreState } from '../../forms/types'

export interface Props {
	appMetaData?: AppMetaData
	ready: boolean
	lastUpdated?: number
	downloadingMetaData: boolean // even though we don't use this prop in the component (because we set local component state instead) we still need to store in props to trigger a DIFF incase network request fails
	selectedLanguage?: Language
	appManifest?: Manifest
	forms: FormStoreState
}

export interface Actions {
	loadAppMetaData: () => void
	checkForUpdates: () => void
	selectLanguage: (language: Language) => void
	downloadManifest: () => void
	loadForm: (id: number, version: number, language: string) => void
}

const mapStateToProps = (state: RootStoreState): Props => ({
	appMetaData: state.settings.appMetaData,
	ready: state.ready,
	lastUpdated: state.settings.lastUpdated,
	downloadingMetaData: state.settings.loadingMetaData,
	selectedLanguage: state.settings.selectedLanguage,
	appManifest: state.settings.appManifest,
	forms: state.forms.forms,
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	loadAppMetaData: () => {
		// this action is listened for by a saga which chooses how best to load the meta data (from assets, disk or async storage)
		dispatch(actions.unpackInitialAssets(undefined))
	},
	checkForUpdates: () => {
		dispatch(checkForUpdates())
	},
	selectLanguage: (language: Language) => {
		dispatch(actions.appLanguageSelected(language))
	},
	downloadManifest: () => {
		const platform = getConfiguration().getPlatform()
		const deviceUUID = getConfiguration().getDeviceUUID()
		dispatch(fetchManifest.started({ devicePlatform: platform, deviceUdid: deviceUUID, isForSync: false }))
	},
	loadForm: (id: number, version: number, language: string) => {
		dispatch(loadForm({ id, version, language }))
	},
})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
